import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.css";

const HomeServiceItem = ({ icon_name = "", title = "", subtitle = "" }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="col-xl-4 col-sm-6">
        <div
          className={`tp-services white-bg mb-30 wow fadeInUp`}
          data-wow-delay=".2s"
        >
          <div className="tp-services-icon yellow-circle-shape">
            <i className={`flaticon-${icon_name}`}></i>
          </div>
          <div className="tp-services-text fix">
            <h4 className="tp-services-text-title mb-15 hover-theme-color">
              {subtitle ? <Link to="/">{title}</Link> : title}
            </h4>
            {subtitle && (
              <>
                {" "}
                <p className="mb-20">{subtitle}</p>
                <div className="tp-services-text-link">
                  <Link to="/quote">
                    <i className="flaticon-enter"></i>{" "}
                    {t("HomeServiceItem.GetQuote")}
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeServiceItem;
